<template>
  <div class="admin-dashboard">
    <!-- Admin Header -->
    <header class="admin-header">
      <div class="admin-nav">
        <div class="admin-brand">
          <img src="/images/aslan-energy-logo-hq.jpg" alt="Aslan Energy" class="admin-brand-logo" />
          <h1>Admin Panel</h1>
        </div>
        <div class="admin-user-menu">
          <span class="admin-welcome">Hoş geldin, {{ adminUser?.username || 'Admin' }}</span>
          <button @click="handleLogout" class="logout-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.59L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
            </svg>
            Çıkış
          </button>
        </div>
      </div>
    </header>

    <div class="admin-layout">
      <!-- Sidebar Navigation -->
      <aside class="admin-sidebar">
        <nav class="admin-menu">
          <button 
            @click="activeSection = 'dashboard'" 
            :class="{ active: activeSection === 'dashboard' }"
            class="menu-item"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
            </svg>
            Dashboard
          </button>

          <button 
            @click="activeSection = 'news'" 
            :class="{ active: activeSection === 'news' }"
            class="menu-item"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
            </svg>
            Haberler
          </button>

          <button 
            @click="activeSection = 'projects'" 
            :class="{ active: activeSection === 'projects' }"
            class="menu-item"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 0 0-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"/>
            </svg>
            Projeler
          </button>

          <button 
            @click="activeSection = 'services'" 
            :class="{ active: activeSection === 'services' }"
            class="menu-item"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            Hizmetler
          </button>

          <button 
            @click="activeSection = 'hero-slides'" 
            :class="{ active: activeSection === 'hero-slides' }"
            class="menu-item"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zm-10-7l2.5 3.01L17.5 11 21 16H3l4-5z"/>
            </svg>
            Hero Slider
          </button>

          <button 
            @click="activeSection = 'machinery'" 
            :class="{ active: activeSection === 'machinery' }"
            class="menu-item"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M22 9V7l-2-2h-4V2h-4v3H8l-2 2v2H2v9h4v3h12v-3h4V9h-2zm-8 10H10v-2h4v2zm0-3H10v-2h4v2zm6-1h-2v3h-2v-3H4V10h12v2h2v-2h2v5z"/>
            </svg>
            Makine Parkı
          </button>

          <button 
            @click="activeSection = 'info-cards'" 
            :class="{ active: activeSection === 'info-cards' }"
            class="menu-item"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8.5 9.67l1.69 2.26 2.48-3.1L19 15H5l3.5-4.33 3 3.83z"/>
            </svg>
            Info Cards
          </button>

          <button 
            @click="activeSection = 'about'" 
            :class="{ active: activeSection === 'about' }"
            class="menu-item"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
            </svg>
            Hakkımızda
          </button>

          <button 
            @click="activeSection = 'statistics'" 
            :class="{ active: activeSection === 'statistics' }"
            class="menu-item"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>
            </svg>
            İstatistikler
          </button>

          <button 
            @click="activeSection = 'contacts'" 
            :class="{ active: activeSection === 'contacts' }"
            class="menu-item"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
            </svg>
            İletişim Mesajları
            <span v-if="unreadCount > 0" class="badge">{{ unreadCount }}</span>
          </button>
        </nav>

        <div class="sidebar-footer">
          <button @click="goToSite" class="back-to-site-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
            </svg>
            Ana Siteye Dön
          </button>
        </div>
      </aside>

      <!-- Main Content -->
      <main class="admin-main">
        <!-- Dashboard Overview -->
        <div v-if="activeSection === 'dashboard'" class="admin-content">
          <div class="content-header">
            <h2>Dashboard</h2>
            <p>Aslan Energy yönetim paneline hoş geldiniz</p>
          </div>
          
          <div class="stats-grid">
            <div class="stat-card">
              <div class="stat-icon news">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                </svg>
              </div>
              <div class="stat-content">
                <h3>{{ stats.news || 0 }}</h3>
                <p>Toplam Haber</p>
              </div>
            </div>

            <div class="stat-card">
              <div class="stat-icon projects">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 0 0-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2z"/>
                </svg>
              </div>
              <div class="stat-content">
                <h3>{{ stats.projects || 0 }}</h3>
                <p>Toplam Proje</p>
              </div>
            </div>

            <div class="stat-card">
              <div class="stat-icon services">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
              </div>
              <div class="stat-content">
                <h3>{{ stats.services || 0 }}</h3>
                <p>Aktif Hizmet</p>
              </div>
            </div>

            <div class="stat-card">
              <div class="stat-icon messages">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4l4 4 4-4h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
                </svg>
              </div>
              <div class="stat-content">
                <h3>{{ stats.contacts || 0 }}</h3>
                <p>Yeni Mesaj</p>
              </div>
            </div>

            <div class="stat-card">
              <div class="stat-icon hero-slides">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                  <path d="M21 6l-2.5-1.4L16 6v5l2.5 1.4L21 11V6z"/>
                </svg>
              </div>
              <div class="stat-content">
                <h3>{{ stats.heroSlides || 0 }}</h3>
                <p>Aktif Hero Slider</p>
              </div>
            </div>

            <div class="stat-card">
              <div class="stat-icon machinery">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/>
                </svg>
              </div>
              <div class="stat-content">
                <h3>{{ stats.machinery || 0 }}</h3>
                <p>Aktif Makine</p>
              </div>
            </div>

            <div class="stat-card">
              <div class="stat-icon info-cards">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M11 9h2V7h-2m1 13c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-1 15h2v-6h-2v6z"/>
                </svg>
              </div>
              <div class="stat-content">
                <h3>{{ stats.infoCards || 0 }}</h3>
                <p>Aktif Info Card</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Haber Yönetimi Section -->
        <AdminNews 
          v-else-if="activeSection === 'news'" 
          @statsUpdated="handleNewsStatsUpdate"
        />

        <!-- Proje Yönetimi Section -->
        <AdminProjects 
          v-else-if="activeSection === 'projects'" 
          @statsUpdated="handleProjectStatsUpdate"
        />

        <!-- Hizmet Yönetimi Section -->
        <AdminServices 
          v-else-if="activeSection === 'services'" 
          @statsUpdated="handleServiceStatsUpdate"
        />

        <!-- Hero Slider Yönetimi Section -->
        <AdminHeroSlides 
          v-else-if="activeSection === 'hero-slides'" 
          @statsUpdated="handleHeroSlidesStatsUpdate"
        />

        <!-- Hakkımızda Yönetimi Section -->
        <AdminAbout 
          v-else-if="activeSection === 'about'"
        />

        <!-- İstatistikler Yönetimi Section -->
        <AdminStatistics 
          v-else-if="activeSection === 'statistics'"
        />

        <!-- Makine Parkı Section -->
        <AdminMachinery 
          v-else-if="activeSection === 'machinery'" 
          @statsUpdated="handleMachineryStatsUpdate"
        />

        <!-- Info Cards Yönetimi Section -->
        <AdminInfoCards 
          v-else-if="activeSection === 'info-cards'"
        />

        <!-- İletişim Mesajları Section -->
        <AdminContacts 
          v-else-if="activeSection === 'contacts'" 
          @statsUpdated="handleContactStatsUpdate"
        />

        <!-- Other Sections Placeholder -->
        <div v-else class="admin-content">
          <div class="content-header">
            <h2>{{ getSectionTitle() }}</h2>
            <p>Bu bölüm geliştiriliyor...</p>
          </div>

          <div class="placeholder-content">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="currentColor" opacity="0.3">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <p>{{ getSectionTitle() }} yönetimi yakında aktif olacak</p>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, onUnmounted, computed } from 'vue'
import { adminApi, adminAuth } from '@/services/adminApi'
import AdminContacts from './admin/AdminContacts.vue'
import AdminNews from './admin/AdminNews.vue'
import AdminProjects from '@/components/AdminProjects.vue'
import AdminServices from '@/components/AdminServices.vue'
import AdminHeroSlides from '@/components/AdminHeroSlides.vue'
import AdminAbout from '@/components/AdminAbout.vue'
import AdminStatistics from '@/components/AdminStatistics.vue'
import AdminMachinery from '@/components/AdminMachinery.vue'
import AdminInfoCards from '@/components/AdminInfoCards.vue'

const emit = defineEmits(['navigate'])

const activeSection = ref('dashboard')
const stats = reactive({
  news: 0,
  projects: 0,
  services: 0,
  contacts: 0,
  heroSlides: 0,
  machinery: 0,
  infoCards: 0
})
const unreadCount = ref(0)

const adminUser = computed(() => adminAuth.getUser())

const getSectionTitle = () => {
  const titles = {
    dashboard: 'Dashboard',
    news: 'Haber Yönetimi',
    projects: 'Proje Yönetimi',
    services: 'Hizmet Yönetimi',
    machinery: 'Makine Parkı Yönetimi',
    'hero-slides': 'Hero Slider Yönetimi',
    about: 'Hakkımızda Yönetimi',
    statistics: 'İstatistik Yönetimi',
    contacts: 'İletişim Mesajları'
  }
  return titles[activeSection.value] || 'Yönetim Paneli'
}

const loadDashboardStats = async () => {
  try {
    // Load contact stats - yeni mesaj sayısı (is_read = 0)
    const contactResponse = await adminApi.getContacts()
    if (contactResponse.success) {
      const unreadMessages = contactResponse.data.filter(msg => 
        parseInt(msg.is_read) === 0
      )
      stats.contacts = unreadMessages.length
      unreadCount.value = unreadMessages.length
    }
    
    // Load news stats
    const newsResponse = await adminApi.getNews({ limit: 1000 }) // Get all news for counting
    if (newsResponse.success) {
      stats.news = newsResponse.data.pagination.total
    }
    
    // Load project stats - dropdown bağımsız toplam
    const projectResponse = await adminApi.getProjects({ limit: 1 }) // Sadece stats için, az data yeter
    if (projectResponse.success) {
      stats.projects = projectResponse.data.total_all_projects || 0
    }
    
    // Load services stats - sadece aktif hizmetleri say
    try {
      const servicesResponse = await adminApi.getServices()
      if (servicesResponse.success) {
        const activeServices = servicesResponse.data?.filter(service => parseInt(service.is_active) === 1) || []
        stats.services = activeServices.length
      }
    } catch (error) {
      console.error('Services stats yüklenemedi:', error)
      stats.services = 0
    }

    // Load hero slides stats - sadece aktif slide'ları say
    try {
      const heroSlidesResponse = await adminApi.getHeroSlides({ admin: true })
      if (heroSlidesResponse.success) {
        // API doğrudan slides array'i döndürüyor
        const slides = heroSlidesResponse.data || []
        const activeSlides = slides.filter(slide => parseInt(slide.is_active) === 1)
        stats.heroSlides = activeSlides.length
      }
    } catch (error) {
      console.error('Hero slides stats yüklenemedi:', error)
      stats.heroSlides = 0
    }

    // Load machinery stats - sadece aktif makineleri say
    try {
      const machineryResponse = await adminApi.getMachinery()
      if (machineryResponse.success) {
        // API'den gelen total_active_machinery sayısını kullan
        stats.machinery = machineryResponse.data?.total_active_machinery || 0
      }
    } catch (error) {
      console.error('Machinery stats yüklenemedi:', error)
      stats.machinery = 0
    }

    // Load info cards stats - sadece aktif kartları say
    try {
      console.log('🔄 Loading info cards stats...')
      const infoCardsResponse = await adminApi.getInfoCards()
      console.log('📊 Info cards response:', infoCardsResponse)
      
      if (infoCardsResponse.success) {
        // API doğrudan cards array'i döndürüyor
        const cards = infoCardsResponse.data || []
        console.log('📝 All cards:', cards)
        const activeCards = cards.filter(card => parseInt(card.is_active) === 1)
        console.log('✅ Active cards:', activeCards)
        stats.infoCards = activeCards.length
        console.log('📈 Active cards count:', stats.infoCards)
      } else {
        console.log('❌ Info cards response not successful:', infoCardsResponse)
        stats.infoCards = 0
      }
    } catch (error) {
      console.error('❗ Info cards stats yüklenemedi:', error)
      stats.infoCards = 0
    }
  } catch (error) {
    console.error('Stats yüklenemedi:', error)
    // Fallback values
    stats.contacts = 0
    stats.news = 0
    stats.heroSlides = 0
    stats.machinery = 0
    stats.infoCards = 0
    unreadCount.value = 0
  }
}

const handleLogout = async () => {
  try {
    await adminApi.logout()
  } catch (error) {
    console.log('Logout error:', error)
  } finally {
    emit('navigate', 'admin-login')
  }
}

const goToSite = () => {
  emit('navigate', 'home')
}

const handleContactStatsUpdate = (contactStats) => {
  stats.contacts = contactStats.unread
  unreadCount.value = contactStats.unread
}

const handleNewsStatsUpdate = (newsStats) => {
  stats.news = newsStats.total
}

const handleProjectStatsUpdate = (projectStats) => {
  stats.projects = projectStats.total
}

const handleServiceStatsUpdate = (serviceStats) => {
  stats.services = serviceStats.active
}

const handleMachineryStatsUpdate = (machineryStats) => {
  stats.machinery = machineryStats.total
}

const handleHeroSlidesStatsUpdate = (slidesStats) => {
  // Hero slides için ayrı stats tutmuyoruz, sadece log'luyoruz
  console.log('Hero slides stats updated:', slidesStats)
}

onMounted(() => {
  loadDashboardStats()
  // Hide main header for admin pages
  document.body.classList.add('admin-page')
})

onUnmounted(() => {
  // Remove admin class when leaving admin page
  document.body.classList.remove('admin-page')
})
</script>

<style scoped>
.admin-dashboard {
  min-height: 100vh;
  background: #f8fafc;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  margin: 0;
  padding: 0;
  position: relative;
  top: 0;
}

.admin-header {
  background: white;
  border-bottom: 1px solid #e2e8f0;
  padding: 0 24px;
  height: 64px;
  position: sticky;
  top: 0;
  z-index: 100;
}

.admin-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.admin-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.admin-brand-logo {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.admin-brand h1 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
}

.admin-user-menu {
  display: flex;
  align-items: center;
  gap: 16px;
}

.admin-welcome {
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
}

.logout-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #ef4444;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
}

.logout-btn:hover {
  background: #dc2626;
}

.admin-layout {
  display: flex;
  height: calc(100vh - 64px);
}

.admin-sidebar {
  width: 280px;
  background: white;
  border-right: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
}

.admin-menu {
  flex: 1;
  padding: 24px 0;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 24px;
  background: none;
  border: none;
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.menu-item:hover {
  background: #f1f5f9;
  color: #3b82f6;
}

.menu-item.active {
  background: #eff6ff;
  color: #3b82f6;
}

.menu-item.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: #3b82f6;
}

.badge {
  background: #ef4444;
  color: white;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  margin-left: auto;
}

.sidebar-footer {
  padding: 24px;
  border-top: 1px solid #e2e8f0;
}

.back-to-site-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  background: #f1f5f9;
  color: #64748b;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.back-to-site-btn:hover {
  background: #e2e8f0;
  color: #475569;
}

.admin-main {
  flex: 1;
  overflow-y: auto;
}

.admin-content {
  padding: 32px;
  max-width: 1200px;
}

.content-header {
  margin-bottom: 32px;
}

.content-header h2 {
  margin: 0 0 8px 0;
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
}

.content-header p {
  margin: 0;
  color: #64748b;
  font-size: 16px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
}

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 16px;
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.stat-icon.news { background: #3b82f6; }
.stat-icon.projects { background: #10b981; }
.stat-icon.services { background: #f59e0b; }
.stat-icon.contacts { background: #ef4444; }
.stat-icon.messages { background: #ef4444; }
.stat-icon.hero-slides { background: #0288d1; }
.stat-icon.machinery { background: #e53e3e; }
.stat-icon.info-cards { background: #8b5cf6; }

.stat-content h3 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
}

.stat-content p {
  margin: 4px 0 0 0;
  color: #64748b;
  font-size: 14px;
}

.placeholder-content {
  text-align: center;
  padding: 64px 32px;
  color: #64748b;
}

.placeholder-content p {
  margin: 16px 0 0 0;
  font-size: 16px;
}

@media (max-width: 1024px) {
  .admin-sidebar {
    width: 240px;
  }
}

@media (max-width: 768px) {
  .admin-layout {
    flex-direction: column;
  }
  
  .admin-sidebar {
    width: 100%;
    height: auto;
  }
  
  .admin-menu {
    display: flex;
    overflow-x: auto;
    padding: 16px 0;
  }
  
  .menu-item {
    flex-shrink: 0;
    white-space: nowrap;
  }
}
</style>